import styled from "styled-components";
import {
  DefaultParagraphLargeFactory,
  DefaultTitleLargeFactory,
} from "../../../../components/Habitacional/core/Typograph/Typograph.Style";

export const ActivateInsuranceSectionContainer = styled.section(
  ({ theme }) => ({
    background: `${theme.color.neutral["08"]} !important`,
    paddingTop: "40px",
    paddingBottom: "40px",
    marginBottom: "0 !important",
    display: "flex",
    flexDirection: "column",
    gap: "20px",

    [theme.breakpoint.lg()]: {
      paddingTop: "60px",
      paddingBottom: "60px",
      gap: "40px",
    },
  })
);

export const ActivateInsuranceSectionTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
}));

export const ActivateInsuranceSectionContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",

  [theme.breakpoint.lg()]: {
    gap: "64px",
    flexDirection: "row ",
  },
}));

export const ActivateInsuranceSectionImage = styled.img(({ theme }) => ({
  maxWidth: "100%",
  width: "100%",
  height: "auto",
  objectFit: "contain",

  [theme.breakpoint.lg()]: {
    width: "170px",
    height: "170px",
  },
}));

export const ActivateInsuranceSectionBlock = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  gap: "20px",

  [theme.breakpoint.lg()]: {
    alignItems: "flex-start",
    gap: "40px",
  },

  ".phone-number": {
    ...DefaultTitleLargeFactory({ theme }),
    fontWeight: "400",
  },
}));

export const ActivateInsuranceSectionBlockDescription = styled.p(
  ({ theme }) => ({
    ...DefaultParagraphLargeFactory({ theme }),
  })
);
